    <template>
    <div>
     <div class="bg-pink-lighter">
     <div class="px-4 py-4">
       <div
         class=" md:mx-32 md:flex md:items-center md:justify-between"
       >
         <div class="flex justify-between items-center">
           <router-link to="/home"  class="inline-block border-b-4 border-green-600 text-3xl font-bold"
             >HomeDeals
           </router-link >

         </div>

           <div class="md:block">
             <router-link to="/contact"
             href="#"
             class="inline-block rounded-lg border-2 mr-2 border-black py-1 px-1 mt-2 hover:bg-black hover:text-white"
             >Contact us  </router-link >
              <router-link to="/about"
             href="#"
             class="inline-block rounded-lg border-2 border-black py-1 px-1 mt-2  hover:bg-black hover:text-white"
             >About  </router-link >

         </div>

       </div>
     </div>

     </div>
    </div>

</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  data() {
    return {
      isOpen: false,
      type: [
        { name: 'illness', selected: false },
        { name: 'contraceptive', selected: false },
        { name: 'other', selected: false },
      ],
      selectedType: 'illness',
      selected: 'illness',
      options: [
        { text: 'illness', value: 'illness' },
        { text: 'contraceptive', value: 'contraceptive' },
        { text: 'other', value: 'other' },
      ],
      restOfCities: [],
      openBox: false,
    };
  },
  computed: {
    ...mapState('app', ['appTitle']),
    ...mapState('search', ['dropdownMainSelected', 'setDropdownSubCatIndex', 'subCatInfo', 'latestkitlist', 'dropdownIndex', 'mainOptions', 'propertylist', 'MainOptionSelected', 'SelectedOption']),
    ...mapState('dropdown', ['dropdownMainSelected', 'dropdownOptions', 'dropdownIndex']),
    ...mapGetters('dropdown', ['getDropdown']),

  },
  methods: {
    ...mapActions('search', ['getSelectedSubcat']),
    populateCities(event) {
      console.log(this.$refs.input);
      event.preventDefault();
      this.openBox = true;
      this.restOfCities = [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ];
      _.remove(this.restOfCities, this.selected);
    },
    setCity(name, event) {
      console.log('blur1!!');
      event.preventDefault();
      this.selected = name;
      _.remove(this.restOfCities, { name, selected: false });
      this.restOfCities = [];
      this.openBox = false;
    },
    setType(type, event) {
      event.preventDefault();
      this.selectedType = type.name;
    },
    loadSelect(name, event) {
      event.preventDefault();
      console.log(name);
      this.selectedType = name;
    },
    search(name, event) {
      event.preventDefault();
    },
    handleBlur() {
      this.restOfCities = this.selected;
      console.log('blur2!!');
    },
    away() {
      this.restOfCities = [];
    },
  },
  async mounted() {
    this.getSelectedSubcat();
  },
  created() {
    const self = this;
    window.addEventListener('click', () => {
      if (self.openBox === true) {
        self.restOfCities = [];
      }
    });
  },
};
</script>
